"use strict";

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(require("react"));

var decentraland_ui_1 = require("decentraland-ui");

var utils_1 = require("../../modules/translation/utils");

var utils_2 = require("../../lib/utils");

var eth_1 = require("../../lib/eth");

var LoginModal_1 = __importDefault(require("../LoginModal"));

var SignInPage = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(SignInPage, _React$PureComponent);

  function SignInPage(props) {
    var _this;

    _classCallCheck(this, SignInPage);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SignInPage).call(this, props));

    _this.handleToggleLoginModal = function () {
      var isLoginModalOpen = !_this.state.isLoginModalOpen;

      _this.setState({
        isLoginModalOpen: isLoginModalOpen
      });
    };

    _this.getTranslations = function () {
      var _this$props = _this.props,
          hasTranslations = _this$props.hasTranslations,
          isConnected = _this$props.isConnected;

      if (!hasTranslations) {
        return undefined;
      }

      return {
        header: React.createElement(utils_1.T, {
          id: "@dapps.sign_in.get_started"
        }),
        error: React.createElement(utils_1.T, {
          id: "@dapps.sign_in.error"
        }),
        connect: React.createElement(utils_1.T, {
          id: "@dapps.sign_in.connect"
        }),
        connecting: React.createElement(utils_1.T, {
          id: "@dapps.sign_in.connecting"
        }),
        connected: React.createElement(utils_1.T, {
          id: "@dapps.sign_in.connected"
        }),
        message: isConnected ? React.createElement(utils_1.T, {
          id: "@dapps.sign_in.options.connected"
        }) : eth_1.isCucumberProvider() ? React.createElement(utils_1.T, {
          id: "@dapps.sign_in.options.samsung",
          values: {
            samsung_link: React.createElement("a", {
              href: "https://www.samsung.com/global/galaxy/apps/samsung-blockchain/",
              target: "_blank",
              rel: "noopener noreferrer"
            }, "Samsung Blockchain Wallet")
          }
        }) : utils_2.isMobile() ? React.createElement(utils_1.T, {
          id: "@dapps.sign_in.options.mobile",
          values: {
            coinbase_link: React.createElement("a", {
              href: "https://wallet.coinbase.com",
              target: "_blank",
              rel: "noopener noreferrer"
            }, "Coinbase Wallet"),
            imtoken_link: React.createElement("a", {
              href: "https://token.im",
              target: "_blank",
              rel: "noopener noreferrer"
            }, "imToken")
          }
        }) : React.createElement(utils_1.T, {
          id: "@dapps.sign_in.options.desktop",
          values: {
            metamask_link: React.createElement("a", {
              href: "https://metamask.io",
              target: "_blank",
              rel: "noopener noreferrer"
            }, "MetaMask"),
            ledger_nano_link: React.createElement("a", {
              href: "https://www.ledger.com/",
              target: "_blank",
              rel: "noopener noreferrer"
            }, "Ledger Nano S")
          }
        })
      };
    };

    _this.state = {
      isLoginModalOpen: false
    };
    return _this;
  }

  _createClass(SignInPage, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          center = _this$props2.center,
          isConnected = _this$props2.isConnected,
          isConnecting = _this$props2.isConnecting,
          hasError = _this$props2.hasError,
          onConnect = _this$props2.onConnect;
      var isLoginModalOpen = this.state.isLoginModalOpen;
      return React.createElement(React.Fragment, null, React.createElement(decentraland_ui_1.SignIn, {
        center: center,
        isConnected: isConnected,
        isConnecting: isConnecting,
        hasError: hasError,
        onConnect: this.handleToggleLoginModal,
        i18n: this.getTranslations()
      }), React.createElement(LoginModal_1.default, {
        open: isLoginModalOpen,
        onConnect: onConnect,
        onClose: this.handleToggleLoginModal
      }));
    }
  }]);

  return SignInPage;
}(React.PureComponent);

exports.default = SignInPage;